import { addSavedOffer } from '@cian/favorites-assign-widget';

import { addToFavoriteRequest as _addToFavorite } from '.';
import { TThunkAction } from '../../../types/redux';
import {
  EDealType,
  EEntityType,
} from 'shared/repositories/favorites/entities/add_favorite/AddFavoriteEntityPublicRequestSchema';
import { updateFavorite } from 'shared/types/actions/favorites/actions';
interface IAddToFavoriteProps {
  offerId: number;
  dealType: EDealType;
  entityType: EEntityType;
  currentCount: number;
}

export const addToFavorite =
  ({ offerId, dealType, entityType, currentCount }: IAddToFavoriteProps): TThunkAction<Promise<void>> =>
  async (dispatch, _getState, context) => {
    try {
      const addToFavoriteResult = await _addToFavorite(context, {
        offerId,
        dealType,
        entityType,
      });
      dispatch(updateFavorite({ offerId, isFavorite: true }));

      const userHasFolders = Boolean(addToFavoriteResult.hasFolders);
      const folder = addToFavoriteResult.folder;

      const savedInFolders =
        folder && folder.name && folder.id
          ? [
              {
                id: folder.id,
                name: folder.name,
              },
            ]
          : null;

      dispatch(addSavedOffer({ offerIds: [offerId], savedInFolders, userHasFolders }));

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (window as any).__header_favorites_count__ = currentCount + 1;

      return window.__header_updateFavorites__ && window.__header_updateFavorites__(true);
    } catch (error) {
      context.logger.error(error, {
        offerId,
        domain: 'addToFavorite',
      });
    }
  };
